import { TranslateService } from '@ngx-translate/core';
import { LOCATION_INITIALIZED } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { inject } from '@angular/core';

/**
 * Загрузка русского словаря приложения независимо от языка браузера.
 */
export const translateInitializer = (): Promise<unknown> => {
  const locationInitialized =
    inject(LOCATION_INITIALIZED, { optional: true }) ?? Promise.resolve(null);
  const translateService = inject(TranslateService);

  return locationInitialized.then(() =>
    firstValueFrom(translateService.use('ru')),
  );
};
